import React from "react";
import LoadingScreenStyle from "./index.module.css";

function LoadingScreen(){
    return (
        <React.Fragment>
            <div className={LoadingScreenStyle.LoadingContainer}>
                <div className={LoadingScreenStyle.MainContainer} />
                <div className={LoadingScreenStyle.LoaderText}>
                    <strong>Himanshu Clones</strong>
                </div>
            </div>
        </React.Fragment>
    )

}


export default LoadingScreen;